const GIPHY_COMPAT_BASE = 'https://api.giphy.com/v2';
const GIF_CLIENT_KEY = 'cime_plus';

/** Client-side GIPHY key (same exposure class as the former Tenor key). Override with VITE_GIPHY_API_KEY. */
const DEFAULT_GIPHY_API_KEY = 'sXpGFDGZs0Dv1mmNFvYaGUvYwKX0PWIh';

export type GifHit = {
  id: string;
  title: string;
  previewUrl: string;
  url: string;
};

export function getGiphyApiKey(): string {
  const fromEnv = import.meta.env.VITE_GIPHY_API_KEY;
  if (typeof fromEnv === 'string' && fromEnv.length > 0) return fromEnv;
  return DEFAULT_GIPHY_API_KEY;
}

export function buildGifSearchUrl(query: string, key = getGiphyApiKey()): string {
  const params = new URLSearchParams({
    key,
    client_key: GIF_CLIENT_KEY,
    limit: '30',
    media_filter: 'tinygif,gif',
    contentfilter: 'medium',
    locale: 'fr_FR',
    country: 'FR',
  });
  const q = query.trim();
  if (q) params.set('q', q);
  const path = q ? 'search' : 'featured';
  return `${GIPHY_COMPAT_BASE}/${path}?${params.toString()}`;
}

export function parseGifSearchResponse(data: unknown): GifHit[] {
  if (!data || typeof data !== 'object') return [];
  const results = (data as { results?: unknown }).results;
  if (!Array.isArray(results)) return [];

  const hits: GifHit[] = [];
  for (const item of results) {
    if (!item || typeof item !== 'object') continue;
    const rec = item as {
      id?: unknown;
      title?: unknown;
      media_formats?: { tinygif?: { url?: string }; gif?: { url?: string } };
    };
    const id = typeof rec.id === 'string' ? rec.id : '';
    const previewUrl = rec.media_formats?.tinygif?.url ?? rec.media_formats?.gif?.url ?? '';
    const url = rec.media_formats?.gif?.url ?? previewUrl;
    if (!id || !previewUrl) continue;
    hits.push({
      id,
      title: typeof rec.title === 'string' ? rec.title : '',
      previewUrl,
      url,
    });
  }
  return hits;
}

export function isGifMessageUrl(text: string): boolean {
  const t = text.trim();
  return (
    /^https?:\/\/.+\.(gif|GIF)(\?.*)?$/.test(t) ||
    t.includes('tenor.com') ||
    t.includes('media.tenor') ||
    t.includes('giphy.com') ||
    t.includes('media.giphy')
  );
}
